<div class="card-body p-t-1 p-3">
  <div *ngIf="errorMessage" class="alert alert-warning" role="alert">{{errorMessage}}</div>
  <app-rss-feed [entries]="feedData" type="whitepaper" [loaded]="!loading"></app-rss-feed>
</div>
